import type { SVGProps } from 'react';
const SvgChevronArrowLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M15.348 6.276a.9.9 0 0 1-.025 1.273L10.598 12l4.725 4.451a.9.9 0 1 1-1.247 1.298l-5.4-5.1a.9.9 0 0 1 0-1.298l5.4-5.1a.9.9 0 0 1 1.272.025"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgChevronArrowLeft;
